
import React from "react";
import {
  Form,
  SaveButton,   
  Toolbar,
  useTranslate
} from "react-admin";
import { generateInputField } from "../factory";
import {
  useMediaQuery, Typography, Box, Grid

} from '@mui/material';

import Button from '@mui/material/Button';



const UiInlineForm = ({ canDelete,resourcesTabs, ...props }) => (

  <Form
  {...props}
    render={({ resourcesFields,  tabs,  formProps,onCancel,id, ...props }) => (
      // here starts the custom form layout
      <form>
        <div dir={'rtl'} style={{ padding: 1 }}>
          {tabs.map((t, index) => {

            return (
              <>
                {resourcesFields[index] && resourcesFields[index].map((f, fieldIndex) => {
                  // Create unique key using source_name + fieldIndex
                  const uniqueKey = `input-${fieldIndex}-${f.source_name || fieldIndex}`;
                  return generateInputField(f, uniqueKey, id);
                })}


              </>

            );


          }

          )}

        </div>
        <Toolbar {...props}>
          <SaveButton {...props} />
          <Button {...props} onClick={onCancel}>الغاء</Button>
        </Toolbar>
      </form>
    )}
  />
);



export default UiInlineForm;